import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=2cf24724&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=2cf24724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf24724",
  null
  
)

export default component.exports